import { Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { connect } from "react-redux";
import { ReactComponent as ArrowDownSvg } from "../../assets/ArrowDown.svg"

export default connect(
    ({

        users,
    }) => ({

        users,
    }),
    {

    }
)((props) => {

    const [anchorEl, setAnchorEl] = useState(null); // to show list of unassignes notifications 
    const open = Boolean(anchorEl);


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget); // open menu at the clicked element
        event.stopPropagation();

    };

    const handleClose = (e) => {
        setAnchorEl(null);
        e.stopPropagation();
    };

    const handleUserClick = (e,usernodeid) => {
        setAnchorEl(null);
        e.stopPropagation();
        props.handleUserClick(usernodeid,props.notificationnodeid,props.notificationusernodeid)
    }


    let _usersList = props.users?.length ? props.users.map((user) => {
        return <MenuItem style={{ display: user.user.nodeid === props.notificationusernodeid ? "none" : "block"}} onClick={(e)=>{handleUserClick(e,user?.user?.nodeid)}}>{user?.user?.givenname + " " + user?.user?.surname}</MenuItem>
    }) : []

    return (<div className="dnd_ntfOnHoverParent" onClick={handleClick}>

        <Menu anchorEl={anchorEl} open={open} onClose={handleClose}  className="usersMenuList">
            <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                {_usersList}
            </div>
        </Menu>
        <div className="_content">
            Person zumeisen  <ArrowDownSvg />
        </div>
    </div>)
})
